export function encodeRouteToHash(route) {
  const payload = {
    n: route.name,
    p: route.profile || 'driving',
    w: route.waypoints.map(wp => ({
      a: parseFloat(wp.lat.toFixed(6)),
      o: parseFloat(wp.lng.toFixed(6)),
      l: wp.name || '',
    })),
  };
  return btoa(unescape(encodeURIComponent(JSON.stringify(payload))));
}

export function decodeRouteFromHash(encoded) {
  try {
    const json = decodeURIComponent(escape(atob(encoded)));
    const payload = JSON.parse(json);
    return {
      id: null,
      name: payload.n || 'Shared Route',
      profile: payload.p || 'driving',
      waypoints: (payload.w || []).map(w => ({
        lat: w.a,
        lng: w.o,
        name: w.l || '',
      })),
      geometry: null,
      distance: null,
      duration: null,
    };
  } catch {
    return null;
  }
}

export function buildShareURL(route) {
  const hash = encodeRouteToHash(route);
  const url = new URL(window.location.href);
  url.hash = `route=${hash}`;
  return url.toString();
}

export async function copyToClipboard(text) {
  if (navigator.clipboard) {
    await navigator.clipboard.writeText(text);
  } else {
    const el = document.createElement('textarea');
    el.value = text;
    el.style.position = 'fixed';
    el.style.opacity = '0';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  }
}
